module.exports = __webpack_public_path__ + "static/moment-0aa221435bb9b1a17969a5f65327bd36.png";